export { default } from '../(tabs)/profile';
